import axios, { AxiosInstance } from "axios";
import Cookies from "universal-cookie";

const urlBaseApi = process.env.REACT_APP_BASE_API_URL as string;

const cookies = new Cookies();
export const token: string = cookies.get('jwt');

export const http: AxiosInstance = axios.create({
    baseURL: urlBaseApi,
    // timeout: 1000,
    headers: {
        Authorization: `Bearer ${token}`,
    }
});

// Relit les cookies a chaque requete (et non une seule fois a l'import du module)
// pour envoyer le token et le profil selectionne par l'utilisateur au back.
http.interceptors.request.use((config) => {
    const jwtCourant = cookies.get('jwt');
    const profilIdCourant = cookies.get('profil_id');

    if (jwtCourant) {
        config.headers.set('Authorization', `Bearer ${jwtCourant}`);
    }

    if (profilIdCourant) {
        config.headers.set('X-Profil-Id', String(profilIdCourant));
    }

    return config;
});
